import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { loadingOverlay } from "vuetify-more-component";
export default {
  components: {
    loadingOverlay
  },

  data() {
    return {
      loading: false,
      search: "",
      datos_tabla: [],
      dialog_filtro: false,
      dialog_confirmar: false,
      resolveModal: null,
      selectedOptionAnio: 0,
      selectedTipoTransaccion: 0,
      dialog_edit: null,
      filtro_fecha: {
        fecha: 0,
      },
      headers: [
        { text: "Mes", value: "mes" },
        { text: "Año", value: "anio" },
        { text: "Transaccion", value: "id_transaccion" },
        { text: "Codigo", value: "codigo" },
        { text: "Día Solicitud", value: "dia_solicitud" },
        { text: "Día Máximo", value: "dia_maximo" },
        { text: "...", value: "opt", sortable: false },
      ],
      filtro_tipo_transaccion: {
        tipo_transaccion: [
          { text: "Todos", value: 0 },
          { text: "Facturas Emitidas", value: 1 },
          { text: "Facturas Recibidas", value: 2 },
          { text: "Retención IVA", value: 3 },
          { text: "Retención ISR", value: 4 },
          { text: "Declaración IVA Pequeño Contribuyente", value: 5 },
          { text: "Declaración IVA General", value: 6 },
          { text: "Declaración ISR", value: 7 },
          { text: "Consulta Declaración", value: 8 },
          { text: "Generación Factura", value: 9 },
        ]
      },
      months: [
        { text: 'Enero', value: 1 },
        { text: 'Febrero', value: 2 },
        { text: 'Marzo', value: 3 },
        { text: 'Abril', value: 4 },
        { text: 'Mayo', value: 5 },
        { text: 'Junio', value: 6 },
        { text: 'Julio', value: 7 },
        { text: 'Agosto', value: 8 },
        { text: 'Septiembre', value: 9 },
        { text: 'Octubre', value: 10 },
        { text: 'Noviembre', value: 11 },
        { text: 'Diciembre', value: 12 },
      ],
      id_dinamic: null,
      mes_dinamic: null,
      formData: {
        id_transaccion: '',
        codigo: '',
        mes: '',
        anio: '',
        dia_solicitud: '',
        dia_maximo: '',
      },
      dialog: false,
      isEdit: false,
      formValid: false,
      fields: [],
      rules: {
        required: value => !!value || 'Este campo es requerido',
        numeric: value => !isNaN(value) || 'Este campo debe ser numérico',
        year: value => /^\d{4}$/.test(value) || 'Datos incorrectos',
        twoDigitNumber: value => /^\d{1,2}$/.test(value) || 'Datos incorrectos'
      },
    };
  },
  async created() {
    console.log("/transaccion/listado");
    await this.getUsuarios();
  },
  computed: {
    dateRule() {
      return (v) => !!v || "Fecha requerida";
    }
  },
  methods: {
    formatDate(date) {
      console.log("formatDate", date);
      if (!date) return "";
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },
    async getUsuarios() {
      console.log("getUsuarios");
      this.datos_tabla = [];
      this.loading = true;

      console.log("this.filtro_fecha.fecha:", this.filtro_fecha.fecha);
      console.log("this.selectedOptionAnio:", this.selectedOptionAnio);
      console.log("this.selectedTipoTransaccion:", this.selectedTipoTransaccion);

      try {
        let listadoTransaccion = await this.$store.state.services.presentacionService.listadoTransaccion(
          this.filtro_fecha.fecha,
          this.selectedOptionAnio,
          this.selectedTipoTransaccion
        );

        console.log("listadoTransaccion:", listadoTransaccion);
        this.fields = listadoTransaccion.data.data.transacciones;
        listadoTransaccion = listadoTransaccion.data.data.detalle_transaccion;

        if (this.selectedTipoTransaccion !== 0) {
          listadoTransaccion = listadoTransaccion.filter(item => item.id_transaccion === this.selectedTipoTransaccion);
        }

        if (this.filtro_fecha.fecha !== 0) {
          listadoTransaccion = listadoTransaccion.filter(item => item.mes === this.filtro_fecha.fecha);
        }

        if (this.selectedOptionAnio !== 0) {
          const selectedAnio = String(this.selectedOptionAnio).trim(); // Normaliza el valor a cadena y elimina espacios

          // Filtra el listado de transacciones
          listadoTransaccion = listadoTransaccion.filter(item => {
            const itemAnio = String(item.anio).trim(); // Normaliza el valor del año en el item
            return itemAnio === selectedAnio;
          });
        }

        const formattedData = await this.Format_data(listadoTransaccion);
        this.datos_tabla = formattedData;

        this.filtro_fecha.fecha = 0;
        this.selectedOptionAnio = 0;
        this.selectedTipoTransaccion = 0;

      } catch (error) {
        console.log(error);
        this.$toast.warning("No es posible procesar la información");
      }

      this.loading = false;
    },
    async Format_data(data) {
      console.log("Format_data", data);
      try {

        data = data.map((item) => {
          try {
            // Maneja la conversión del mes y proporciona un valor predeterminado si hay problemas
            item.mes = this.months.find((monthsItem) => monthsItem.value === item.mes)?.text || 'Desconocido';
            return {
              id: item.id || 'Desconocido',
              id_transaccion: (item.transaccion.descripcion || 'Desconocido') || 'Desconocido',
              codigo: (item.transaccion.codigo || 'Desconocido') || 'Desconocido',
              dia_solicitud: item.dia_solicitud || 'Desconocido',
              dia_maximo: item.dia_maximo || 'Desconocido',
              mes: item.mes,
              anio: item.anio || 'Desconocido',
            };
          } catch (e) {
            console.log('Ups, ha ocurrido un error:', e);
            // Devuelve un objeto con valores predeterminados en caso de error
            return {
              id: 'Desconocido',
              id_transaccion: 'Desconocido',
              codigo: 'Desconocido',
              dia_solicitud: 'Desconocido',
              dia_maximo: 'Desconocido',
              mes: 'Desconocido',
              anio: 'Desconocido',
            };
          }
        });


        return data;
      } catch (e) {
        console.log('Ups, ha ocurrido un error:', e);
      }
    },
    filtra_tabla() {
      this.filtro_fecha.fecha = 0;
      this.months.unshift({ text: 'Todos', value: 0 });

      this.dialog_filtro = true;
    },
    exportarExcel() {
      const ws = XLSX.utils.json_to_sheet(this.datos_tabla, {
        header: this.headers.map((header) => header.value)
      });
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Datos");
      XLSX.writeFile(wb, "reporte_transaccioes.xlsx");
    },
    exportarPdf() {
      const doc = new jsPDF();

      autoTable(doc, {
        head: [this.headers.map((header) => header.text)],
        body: this.datos_tabla.map((item) =>
          this.headers.map((header) => item[header.value])
        )
      });

      doc.save("reporte_transaccioes.pdf");
    },
    aplicarFiltro() {
      console.log("aplicarFiltro");

      if (this.formData.anio === null || this.formData.anio === '') {
        this.formData.anio = 0;
      }

      this.selectedOptionAnio = this.formData.anio;
      this.dialog_filtro = false;

      this.getUsuarios();
    },
    openForInsert() {
      this.formData = {};
      this.isEdit = false;
      this.dialog_edit = true;
    },
    openForEdit(item, id) {
      console.log('openForEdit', item, id);
      try {
        this.id_dinamic = id;
        this.formData = {};
        let data = { ...item };

        this.mes_dinamic = this.months.find((items) => items.text === data.mes).value;
        console.log('this.fields', this.fields);

        console.log('data.id_transaccion', data.id_transaccion);
        data.id_transaccion = this.fields.find((items) => items.descripcion === data.id_transaccion).id;
        console.log('data.id_transaccion', data.id_transaccion);

        data.mes = this.mes_dinamic;
        this.formData = data;
        this.isEdit = true;
        this.dialog_edit = true;
      } catch (e) {
        console.log(e);
        this.$toast.warning("Este Registro no se puede Actualizar!");
      }
    },
    openForInsertTR() {
      console.log('openForInsertTR');
      this.formData = {};
      this.isEdit = false;
      this.dialog = true;
    },
    async saveTR() {
      console.log('saveTR');
      if (this.$refs.form.validate()) {
        this.dialog = false;
        console.log('insert:', this.formData);
        try {
          this.loading = true;
          let insertTransaccion = await this.$store.state.services.presentacionService.insertTransaccion(
            this.formData
          );

          if (insertTransaccion.data.success) {
            console.log("listadoTransaccion:", insertTransaccion);
            this.$toast.success("Registro Insertado");
            this.formData = {
              id_transaccion: '',
              codigo: '',
              mes: '',
              anio: '',
              dia_solicitud: '',
              dia_maximo: '',
            };
            this.loading = false;
            this.getUsuarios();
          } else {
            console.log('No es posible insertar la información:', insertTransaccion);
            this.$toast.warning("No es posible insertar la información");
            this.formData = {
              id_transaccion: '',
              codigo: '',
              mes: '',
              anio: '',
              dia_solicitud: '',
              dia_maximo: '',
            };
            this.loading = false;
          }
        } catch (error) {
          console.log('No es posible insertar la información:', error);
          this.$toast.warning("No es posible insertar la información");
          this.formData = {
            id_transaccion: '',
            codigo: '',
            mes: '',
            anio: '',
            dia_solicitud: '',
            dia_maximo: '',
          };
          this.loading = false;
        }
      }
    },
    async save() {
      console.log('save');
      if (this.$refs.form.validate()) {
        this.dialog_edit = false;
        if (this.isEdit) {
          this.$set(this.formData, 'id', this.id_dinamic);
          console.log('edit:', this.formData);

          try {
            this.loading = true;
            let updateTransaccion = await this.$store.state.services.presentacionService.updateTransaccion(
              this.formData
            );
            console.log("UpdatetTransaccion", updateTransaccion);
            if (updateTransaccion.data.success) {
              this.$toast.success("Registro Actualizado");
              this.formData = {
                id_transaccion: '',
                codigo: '',
                mes: '',
                anio: '',
                dia_solicitud: '',
                dia_maximo: '',
              };
              this.loading = false;
              this.getUsuarios();
            } else {
              console.log('No es posible actualizar la información:', insertTransaccion);
              this.$toast.warning("No es posible actualizar la información");
              this.formData = {
                id_transaccion: '',
                codigo: '',
                mes: '',
                anio: '',
                dia_solicitud: '',
                dia_maximo: '',
              };
              this.loading = false;
            }
          } catch (error) {
            console.log('No es posible actualizar la información:', error);
            this.$toast.warning("No es posible actualizar la información");
            this.formData = {
              id_transaccion: '',
              codigo: '',
              mes: '',
              anio: '',
              dia_solicitud: '',
              dia_maximo: '',
            };
            this.loading = false;
          }
        } else {
          console.log('insert:', this.formData);
          try {
            this.loading = true;
            let createTransaccion = await this.$store.state.services.presentacionService.createTransaccion(
              this.formData
            );

            if (createTransaccion.data.success) {
              console.log("listadoTransaccion:", createTransaccion);
              this.$toast.success("Registro Insertado");
              this.formData = {
                id_transaccion: '',
                codigo: '',
                mes: '',
                anio: '',
                dia_solicitud: '',
                dia_maximo: '',
              };
              this.loading = false;
              this.getUsuarios();
            } else {
              console.log('No es posible insertar la información:', insertTransaccion);
              this.$toast.warning("No es posible insertar la información");
              this.formData = {
                id_transaccion: '',
                codigo: '',
                mes: '',
                anio: '',
                dia_solicitud: '',
                dia_maximo: '',
              };
              this.loading = false;
            }


          } catch (error) {
            console.log('No es posible insertar la información:', error);
            this.$toast.warning("No es posible insertar la información");
            this.formData = {
              id_transaccion: '',
              codigo: '',
              mes: '',
              anio: '',
              dia_solicitud: '',
              dia_maximo: '',
            };
            this.loading = false;
          }
        }
      }
    },
    async deleteItem(id) {
      console.log('deleteItem', id);

      try {
        const userResponse = await this.openModalDelete();

        // Maneja la respuesta del usuario
        if (userResponse) {
          this.dialog_confirmar = false;
          try {
            this.loading = true;
            let deleteTransaccion = await this.$store.state.services.presentacionService.deleteTransaccion(
              id
            );
            if (deleteTransaccion.data.success) {
              console.log("deleteTransaccion", deleteTransaccion);
              this.$toast.success("Información eliminada");
              this.loading = false;
              this.getUsuarios();
            } else {
              console.log('No es posible eliminar la información:', error);
              this.$toast.warning("No es posible eliminar la información");
              this.formData = {
                id_transaccion: '',
                codigo: '',
                mes: '',
                anio: '',
                dia_solicitud: '',
                dia_maximo: '',
              };
              this.loading = false;
            }

          } catch (error) {
            console.log('No es posible eliminar la información:', error);
            this.$toast.warning("No es posible eliminar la información");
            this.formData = {
              id_transaccion: '',
              codigo: '',
              mes: '',
              anio: '',
              dia_solicitud: '',
              dia_maximo: '',
            };
            this.loading = false;
          }
        } else {
          this.dialog_confirmar = false;
        }
      } catch (error) {
        console.error('Error al manejar la respuesta del modal:', error);
      }

    },
    openModalDelete() {
      this.dialog_confirmar = true;
      // Retorna una promesa que se resolverá cuando el usuario haga clic en el botón del modal
      return new Promise((resolve) => {
        this.resolveModal = resolve;
      });
    },
    cancel_update() {
      console.log('cancel_update');
      this.formData = {
        id_transaccion: '',
        codigo: '',
        mes: '',
        anio: '',
        dia_solicitud: '',
        dia_maximo: '',
      };
      this.dialog = false;
      this.dialog_edit = false;
    },
    handleResponse(result) {
      this.dialog = false; // Cierra el modal
      this.dialog_edit = false;
      if (this.resolveModal) {
        this.resolveModal(result); // Resuelve la promesa con el resultado
      }
    },
  }
};
